import React from "react";

function Thumbnails({ name, onClick, imgSource }) {
  return (
    <div className="flex flex-col items-center justify-end mx-2">
      <div className="hover:scale-110 hover:rotate-2 hover:shadow-lg transition-transform duration-200">
        <img
          src={imgSource}
          alt={name}
          onClick={() => onClick({'src': imgSource, 'title': name})}
          className="max-h-16 object-contain rounded-md shadow-lg shadow-black/20 cursor-pointer"
        />
      </div>

      <div className="text-center text-[11px] text-gray-500 mt-[5px]"
      style={{
            fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", sans-serif',
            fontWeight: 500,
          }}
      >
        {name}
      </div>
    </div>
  );
}

export default Thumbnails;